import { render, staticRenderFns } from "./BookingsSchedule.vue?vue&type=template&id=b3ec6814"
import script from "./BookingsSchedule.vue?vue&type=script&lang=js"
export * from "./BookingsSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports